export default __webpack_public_path__ + "static/media/Modelo 1.28b51083.png";